import { Form } from 'antd'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import InterviewForm from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/InterviewForm'
import OneToOnePreview from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/OneToOnePreview/index'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/CreateSlotDrawer/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import SuccessMessage from 'utils/SuccessMessage'
import { toCamelCase } from '../../../../../utils/camelCase'
import AddLocation from './AddLocationDrawer'
import ChangeLocation from './ChangeLocationDrawer'
import CreateSlot from './CreateSlot'
import ManyToManyPreview from './ManyToManyPreview/index'
import SlotPreviewDrawer from './SlotPreview'

import {
  getNotificationCatalogues,
  sendNotificationBulkEmail,
  sendNotificationBulkEmailWhatsapp,
} from 'modules/Users/actions'
import { useDispatch, useSelector } from 'react-redux'
import { permittedEventCruds } from 'utils/permissionsValidation'

const CreateSlots = ({
  selectedCandidateId,
  selectedCandidate,
  interViewerList,
  rolesMetrics,
  createInterview,
  driveId,
  createSlotDrawer,
  setCreateSlotDrawer,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  selectedRound,
  driveData,
  selectedRoundType,
  candidateDeatils,
  candidateInfoData,
  getCandidateList,
  getRoleMetrics,
  setSelectedCandidateId,
  setSelectedCandidate,
  getInterViewLocation,
  interViewData,
  isSingleOrBulk,
  getCorporateLocationsList,
  singleLocationData,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  updateLocationAPI,
  addCorporateBranch,
}) => {
  const { STD_APP_URL } = process.env
  const dispatch = new useDispatch()
  const [form] = Form.useForm()
  const [preview, setPreview] = useState(false)
  const [slotPreview, setSlotPreview] = useState(false)
  const [checked, setChecked] = useState(null)
  const [schedulePreview, setSchedulePreview] = useState(false)
  const [changeLocationDrawer, setChangeLocationDrawer] = useState(false)
  const [singleLocationChange, setSingleLocationChange] = useState([])
  const [addLocationDrawer, setAddLocationDrawer] = useState(false)
  const [createSloScheduletDrawer, setCreateSloScheduletDrawer] =
    useState(false)
  const [candidates, setCandidates] = useState(0)
  const [selectedRoundName, setSelectedRoundName] = useState(selectedRound)
  const [interviewType, setInterviewType] = useState('')
  const [interviewMode, setInterviewMode] = useState(null)
  const [isOneDayDrive, setIsOneDayDrive] = useState(
    driveData?.startDate === driveData?.endDate
  )
  const [linkPanelData, setLinkPanelData] = useState([
    {
      link: '',
      panel: [{ id: null, firstName: null, lastName: null }],
    },
  ])
  const [addedInterviewer, setAddedInterviewer] = useState([])
  const [dateArr, setDateArr] = useState([])
  const permission = useSelector(state => state?.auth?.permissions)
  const corporateData = useSelector(state => state?.auth?.corporateData)
  const [interviewInfo, setInterviewInfo] = useState({})
  const [interviewdate, setInterviewdate] = useState([])
  const [interviewTime, setInterviewTime] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [confirmedResponse, setConfirmedResponse] = useState({})
  const [selectingStartDate, setSelectingStartDate] = useState('')
  const [selectingEndDate, setSelectingEndDate] = useState('')
  const [dateRange, setDateRange] = useState([])
  const [timeRanges, setTimeRanges] = useState([])
  const [selectedLocationId, setSelectedLocationId] = useState('')
  const [locationLoading, setLocationLoading] = useState(false)

  const [pageNo, setPageNo] = useState(1)
  const [open, setOpen] = useState(false)
  const [parametersList, setParametersList] = useState([])

  const [locations, setLocations] = useState([])
  const [pageChangeCount, setPageChangeCount] = useState(0)
  const [interviewList, setInterviewList] = useState(driveInterViewerList)
  const [interviewSlotsWhatsapp, setInterviewSlotsWhatsapp] = useState(null)
  const [interviewSlotsEmail, setInterviewSlotsEmail] = useState(null)
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Experienced Candidate'
  )
  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''
  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        let responce = await dispatch(getNotificationCatalogues(Schedule?.id))
        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_slot_creation' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray1?.length > 0) {
          setInterviewSlotsWhatsapp(filteredArray1[0].eventNotificationTemplate)
        }
        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'interview_slot_creation' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray2?.length > 0) {
          setInterviewSlotsEmail(filteredArray2[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Schedule])

  useEffect(() => {
    loadMoreData()
  }, [pageNo, pageChangeCount])

  const loadMoreData = async () => {
    const { data } = await getCorporateLocationsList({
      pageLimit: 10,
      currentPage: pageNo,
      setLoading: setLocationLoading,
    })

    if (data?.data?.list?.length) {
      const pendingList =
        pageNo == 1
          ? [...(data?.data?.list || [])]
          : [...locations, ...(data?.data?.list || [])]
      setLocations(pendingList)
    } else {
      setLocations([])
    }
  }

  const resetScrollData = () => {
    setPageNo(1)
    setPageChangeCount(prev => prev + 1)
  }

  const order = rolesMetrics[0]?.rounds
    ?.map(({ roundName }) => roundName)
    .indexOf(selectedRoundType?.roundName)

  const isAssesemntType =
    order === 0 && rolesMetrics[0]?.rounds[0]?.type === 'ASSESMENT'

  const dateFormat = 'YYYY-MM-DD'

  const handleIterviewRound = value => {
    setSelectedRoundName(value)
    form.setFieldsValue({
      interviewRound: value,
    })
  }

  const disabledDate = current => {
    let startDate = moment(driveData?.startDate).format(dateFormat)
    let endDate = moment(driveData?.endDate).format(dateFormat)

    return (
      current < moment() ||
      current < moment(startDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const disabledStartDate = current => {
    let assesmentStartDate = moment(driveData?.startDate)
      .subtract(1, 'months')
      .format(dateFormat)
    let endDate = moment(driveData?.endDate).format(dateFormat)
    return (
      current < moment() ||
      current < moment(assesmentStartDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const disabledEndDate = current => {
    let selectedStartDate = moment(selectingStartDate, 'DD/MM/YYYY').format(
      dateFormat
    )
    let endDate = moment(driveData?.endDate).format(dateFormat)

    return (
      current < moment() ||
      current < moment(selectedStartDate) ||
      current > moment(endDate).endOf('day')
    )
  }

  const onChangeStartDate = (date, dateString) => {
    setSelectingStartDate(dateString)
    form.setFieldsValue({
      startDate: moment(dateString, 'DD/MM/YYYY'),
    })
  }

  const onChangeEndDate = (date, dateString) => {
    setSelectingEndDate(dateString)
    form.setFieldsValue({
      endDate: moment(dateString, 'DD/MM/YYYY'),
    })
  }

  const onChangeDate = (date, dateString) => {
    setDateRange(date)
    form.setFieldsValue({
      dates: dateString,
    })
  }

  const onMultiChangeDates = dateString => {
    form.setFieldsValue({
      dates: dateString,
    })
  }

  const onChangeTimeRange = (date, dateString) => {
    setTimeRanges(date)
    form.setFieldsValue({
      timeRange: dateString,
    })
  }

  const onDurationChange = value => {
    form.setFieldsValue({
      duration: value,
    })
  }

  const onTimeChange = (value, time) => {
    form.setFieldsValue({
      time: time,
    })
  }

  const onChangeMode = value => {
    form.setFieldsValue({
      mode: value,
    })
    setInterviewMode(value)
  }

  const onChangeLink = (e, index) => {
    let linkAndPanel = linkPanelData
    linkAndPanel[index].link = e.target.value
    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const onClickNone = () => {
    setAddedInterviewer('None')
    setLinkPanelData([
      {
        panel: [{ id: null, firstName: null, lastName: null }],
      },
    ])
    form.setFieldsValue({
      linkAndPanel: [
        {
          panel: [{ id: null, firstName: null, lastName: null }],
        },
      ],
    })
  }

  const getUpdatedList = () => {
    let selectedInterviewer = linkPanelData
      ?.map(({ panel }) => panel)
      .flatMap(data => data)
      ?.map(({ id }) => id)
    let updatedInterviewerList = driveInterViewerList.filter(
      data => !selectedInterviewer.includes(data?._id)
    )
    setInterviewList(updatedInterviewerList)
  }

  const onSelectInterview = (value, option, index) => {
    let selectedValue = Array.isArray(value) ? value : [value]
    let selectedOption = Array.isArray(option) ? option : [option]
    setAddedInterviewer(
      selectedValue.filter(item => {
        return item !== 'None'
      })
    )

    let selectedData = selectedOption?.map(({ id, firstName, lastName }) => {
      return { id, firstName, lastName }
    })
    let linkAndPanel = linkPanelData.map((data, indx) => {
      if (index === indx) {
        return { ...data, panel: selectedData }
      } else {
        return data
      }
    })

    setLinkPanelData(linkAndPanel)
    form.setFieldsValue({
      linkAndPanel: linkAndPanel,
    })
  }

  const handlePreview = () => {
    if (interviewMode === 'OFFLINE' && interviewType) {
      setSlotPreview(true)
    } else if (
      interviewType === 'GROUP' ||
      (interviewType === 'FACE_TO_FACE' && isSingleOrBulk)
    ) {
      setSchedulePreview(true)
    } else {
      setPreview(true)
    }
  }

  useEffect(() => {
    getDriveInterviewerList(driveId)
  }, [driveId])

  useEffect(() => {
    getInterViewLocation()
  }, [])

  useEffect(() => {
    setSelectedRoundName(
      selectedRound === 'all_candidates'
        ? candidateInfoData?.stage
        : selectedRound
    )
    form.setFieldsValue({
      interviewRound:
        selectedRound === 'all_candidates'
          ? candidateInfoData?.stage
          : selectedRound,
    })
  }, [selectedRound, candidateInfoData])

  const getMode = () => {
    setIsOneDayDrive(driveData?.startDate === driveData?.endDate)
    form.setFieldsValue({
      dates: moment(driveData?.startDate, dateFormat),
    })
    if (interviewType === 'EXTERNAL_ASSESMENT') {
      setInterviewMode('EXTERNAL_LINK')
    }
  }

  useEffect(() => {
    getMode()
  }, [driveData, interviewType])

  useEffect(() => {
    form.setFieldsValue({
      mode: interviewMode,
    })
  }, [interviewMode])

  useEffect(() => {
    form.setFieldsValue({
      candidatesPerGroup: candidates,
    })
  }, [candidates])

  useEffect(() => {
    if (!preview) {
      setInterviewType(selectedRoundType?.type)
      form.setFieldsValue({
        interviewType: selectedRoundType?.type,
      })
    }
  }, [selectedRoundType, createSlotDrawer])

  useEffect(() => {
    setInterviewList(driveInterViewerList)
  }, [driveInterViewerList])

  const onSubmitFormData = async values => {
    const dates = [
      moment(dateArr[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
      moment(dateArr[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
    ]

    if (
      interviewType === 'ASSESMENT' ||
      interviewType === 'EXTERNAL_ASSESMENT'
    ) {
      setInterviewInfo({ ...values, dates: dates })
      handlePreview()
    } else {
      setInterviewInfo({ ...values, dates: dates })
      scheduleInterview(false, { ...values, dates: dates })
    }
    setInterviewdate(values)

    const timeRange = [
      moment(timeRanges[0], 'HH:mm').format('HH:mm'),
      moment(timeRanges[1], 'HH:mm').format('HH:mm'),
    ]
    setInterviewTime({ timeRange: timeRange })
  }

  const getLinkAndPanelValue = value => {
    let updatedList = []
    if (interviewMode === 'OFFLINE') {
      updatedList = value.map(({ panel }) => {
        return { panel: panel }
      })
    } else if (
      (interviewType === 'ASSESMENT' ||
        interviewType === 'EXTERNAL_ASSESMENT') &&
      interviewMode === 'EXTERNAL_LINK'
    ) {
      updatedList = value.map(({ link }) => {
        return {
          link: link,
          panel: [{ id: '', firstName: '', lastName: '' }],
        }
      })
    } else {
      updatedList = value
    }

    return updatedList
  }

  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
  }
  const labelText = typeLabels[selectedRoundType?.type] || ''
  const messageType = toCamelCase(labelText)

  const scheduleInterview = async (isConfirm, values) => {
    const timeRange = [
      moment(timeRanges[0], 'HH:mm').format('HH:mm'),
      moment(timeRanges[1], 'HH:mm').format('HH:mm'),
    ]

    setIsLoading(true)
    let isBulk =
      selectedCandidate?.length === 10 ||
      selectedCandidate?.length === candidateDeatils?.candidateList?.count
    const feedback = parametersList?.map(item => {
      return {
        qp: 0,
        type: item,
        value: 0,
      }
    })
    let payload = {
      ...values,
      forAllCandidate: isBulk,
      isconfirmed: isConfirm,
      candidatesPerGroup:
        interviewType !== 'GROUP' ? 1 : values?.candidatesPerGroup,

      dates: dateArr,
      timeRange: timeRange,
      studentIds: isSingleOrBulk
        ? selectedCandidate.map(data => {
            return { studentId: data?.student?.id }
          })
        : [{ studentId: selectedCandidateId[0] }],
      linkAndPanel: getLinkAndPanelValue(values?.linkAndPanel),
      time: timeRange[0],
      mode: values?.mode?.includes('EXTERNAL_LINK')
        ? 'EXTERNAL_LINK'
        : values?.mode,
      isSlotCreation: true,
      feedback:
        interviewType != 'ASSESMENT' || interviewType != 'EXTERNAL_ASSESMENT'
          ? feedback
          : [],
    }
    let response = await createInterview(driveId, roleId, payload)
    if (response?.status >= 200 && response?.status <= 300) {
      setIsLoading(false)
      if (isConfirm) {
        SuccessMessage(`${messageType} scheduled successfully!`)
        setCreateSlotDrawer(false)
        form.resetFields()
        form.setFieldsValue({ interviewRound: selectedRoundName })
        form.setFieldsValue({ mode: interviewMode })
        getCandidateList()
        getRoleMetrics(driveId, roleId)
        setSelectedCandidateId([])
        setSelectedCandidate([])
        setSelectingStartDate('')
        setSelectingEndDate('')
        setDateRange([])
        setTimeRanges([])
        setLinkPanelData([
          {
            link: '',
            panel: [{ id: null, firstName: null, lastName: null }],
          },
        ])
        form.setFieldsValue({
          mode: interviewMode,
        })

        if (interviewSlotsWhatsapp) {
          const final = selectedCandidate?.map(item => {
            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.phoneNumber
                : item?.studentPersonalProfile?.phoneNumber,
              templateName: 'interview_slot_creation',
              components: [
                {
                  type: 'HEADER',
                  parameters: [
                    {
                      type: 'IMAGE',
                      image: {
                        link: 'https://drive.google.com/uc?export=view&id=1do69IcSSUj3P6gX202Af8YUF6eCUv5XH',
                      },
                    },
                  ],
                },
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    {
                      type: 'TEXT',
                      text: isSingleOrBulk
                        ? item?.student?.firstName
                        : item?.firstName,
                    },
                    {
                      type: 'TEXT',
                      text: rolesMetrics[0]?.roleName,
                    },
                    {
                      type: 'TEXT',
                      text: corporateData?.name,
                    },

                    {
                      type: 'TEXT',
                      text: `${STD_APP_URL}/driveDetails/${roleId}/${driveId}`,
                    },
                    {
                      type: 'TEXT',
                      text: messageType,
                    },
                  ],
                },
              ],
            }
          })
          dispatch(sendNotificationBulkEmailWhatsapp(final))
        }
        if (interviewSlotsEmail) {
          const final = selectedCandidate?.map(item => {
            const template = interviewSlotsEmail?.templateText
              .replace('{interview}', messageType)
              .replace('{companyName}', corporateData?.name)
              .replace('{roleName}', rolesMetrics[0]?.roleName)
              .replaceAll(
                '{link}',
                `${STD_APP_URL}/driveDetails/${roleId}/${driveId}`
              )

            return {
              to: isSingleOrBulk
                ? item?.student?.studentPersonalProfile?.primaryEmail
                : item?.studentPersonalProfile?.primaryEmail,
              subject: interviewSlotsEmail?.subject,
              htmlBody: template,
            }
          })
          dispatch(sendNotificationBulkEmail(final))
        }
      } else {
        handlePreview()
        setConfirmedResponse(response?.data?.data)
      }
      getMode()

      return true
    } else {
      setIsLoading(false)
      ErrorMessage(response?.response?.data?.message)

      return false
    }
  }

  const handleLocationData = async payload => {
    if (selectedLocationId) {
      let { status } = await updateLocationAPI({
        payload: payload,
        locationId: selectedLocationId,
      })
      if (status >= 200 && status <= 300) {
        resetScrollData()
        return true
      }
    } else {
      let { status } = await addCorporateBranch({
        payload: payload,
      })
      if (status >= 200 && status <= 300) {
        resetScrollData()
        return true
      }
    }
  }

  const content = () => {
    return (
      <InterviewForm
        form={form}
        createSlotDrawer={createSlotDrawer}
        setCreateSlotDrawer={setCreateSlotDrawer}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        driveInterViewerList={driveInterViewerList}
        driveData={driveData}
        setChangeLocationDrawer={setChangeLocationDrawer}
        changeLocationDrawer={changeLocationDrawer}
        candidateDeatils={candidateDeatils}
        SelectedRoundName={selectedRoundName}
        interviewMode={interviewMode}
        isOneDayDrive={isOneDayDrive}
        linkPanelData={linkPanelData}
        setOpen={setOpen}
        open={open}
        setLinkPanelData={setLinkPanelData}
        addedInterviewer={addedInterviewer}
        interviewInfo={interviewInfo}
        isSingleOrBulk={isSingleOrBulk}
        handleIterviewRound={handleIterviewRound}
        disabledDate={disabledDate}
        onChangeDate={onChangeDate}
        onDurationChange={onDurationChange}
        onTimeChange={onTimeChange}
        onChangeTimeRange={onChangeTimeRange}
        onChangeMode={onChangeMode}
        onChangeLink={onChangeLink}
        onClickNone={onClickNone}
        onSelectInterview={onSelectInterview}
        onSubmitFormData={onSubmitFormData}
        interviewType={interviewType}
        dateFormat={dateFormat}
        candidates={candidates}
        setCandidates={setCandidates}
        selectedRoundType={selectedRoundType}
        preview={preview}
        disabledStartDate={disabledStartDate}
        disabledEndDate={disabledEndDate}
        onChangeStartDate={onChangeStartDate}
        onChangeEndDate={onChangeEndDate}
        selectingStartDate={selectingStartDate}
        selectingEndDate={selectingEndDate}
        isAssesemntType={isAssesemntType}
        dateRange={dateRange}
        timeRange={timeRanges}
        interviewList={interviewList}
        getUpdatedList={getUpdatedList}
        isBulk={
          selectedCandidate?.length === 10 ||
          selectedCandidate?.length === candidateDeatils?.candidateList?.count
        }
        interViewData={interViewData}
        checked={checked}
        locations={locations}
        dateArr={dateArr}
        setDateArr={setDateArr}
        singleLocationChange={singleLocationChange}
        setSingleLocationChangeData={setSingleLocationChange}
        onMultiChangeDates={onMultiChangeDates}
        parametersList={parametersList}
        setParametersList={setParametersList}
      />
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          onClick={() => {
            setCreateSlotDrawer(false)
            setPreview(false)
            setOpen(false)
            form.resetFields()
            form.setFieldsValue({ interviewRound: selectedRoundName })
            form.setFieldsValue({ mode: null })
            setSelectingStartDate('')
            setSelectingEndDate('')
            setDateRange([])
            setTimeRanges([])
            setDateArr([])

            setLinkPanelData([
              {
                link: '',
                panel: [{ id: null, firstName: null, lastName: null }],
              },
            ])
            form.setFieldsValue({
              mode: null,
            })
          }}
          width="88px"
          height="38px"
          text="Cancel"
        />

        <Button.Primary
          height="38px"
          text={'Preview & Schedule'}
          form={'scheduleForm'}
          htmlType={'submit'}
          loading={isLoading}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="43%"
        title={isSingleOrBulk ? 'Create Slots' : 'Create Slot'}
        placement="right"
        visible={createSlotDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setCreateSlotDrawer(false)
          setPreview(false)
          setOpen(false)
          form.resetFields()
          form.setFieldsValue({ interviewRound: selectedRoundName })
          form.setFieldsValue({ mode: null })
          setSelectingStartDate('')
          setSelectingEndDate('')
          setDateRange([])
          setTimeRanges([])
          setDateArr([])

          setLinkPanelData([
            {
              link: '',
              panel: [{ id: null, firstName: null, lastName: null }],
            },
          ])
          form.setFieldsValue({
            mode: null,
          })
        }}
        closable
      />
      {schedulePreview && (
        <ManyToManyPreview
          schedulePreview={schedulePreview}
          setSchedulePreview={setSchedulePreview}
          confirmedResponse={confirmedResponse}
          interviewType={interviewType}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setPrivew={setPreview}
          setSlotPrivew={setSlotPreview}
          setDateArr={setDateArr}
        />
      )}
      <CreateSlot
        createSlotDrawer={createSlotDrawer}
        setCreateSlotDrawer={setCreateSlotDrawer}
        createSloScheduletDrawer={createSloScheduletDrawer}
        setCreateSloScheduletDrawer={setCreateSloScheduletDrawer}
        count={candidateDeatils?.candidateList?.count}
        isBulk={
          selectedCandidate?.length === 10 ||
          selectedCandidate?.length === candidateDeatils?.candidateList?.count
        }
        selectedCandidate={selectedCandidate}
        setPrivew={setSchedulePreview}
        preview={schedulePreview}
        interViewData={interViewData}
      />
      {changeLocationDrawer && (
        <ChangeLocation
          changeLocationDrawer={changeLocationDrawer}
          setAddLocationDrawer={setAddLocationDrawer}
          addLocationDrawer={addLocationDrawer}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setChangeLocationDrawer={setChangeLocationDrawer}
          interViewerList={interViewerList}
          driveInterViewerList={driveInterViewerList}
          interViewData={interViewData}
          locations={locations}
          getInterViewLocation={getInterViewLocation}
          checked={checked}
          setChecked={setChecked}
          singleLocationChange={singleLocationChange}
          setSingleLocationChangeData={setSingleLocationChange}
        />
      )}
      {addLocationDrawer && (
        <AddLocation
          changeLocationDrawer={changeLocationDrawer}
          setAddLocationDrawer={setAddLocationDrawer}
          addLocationDrawer={addLocationDrawer}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setChangeLocationDrawer={setChangeLocationDrawer}
          driveInterViewerList={driveInterViewerList}
          interViewData={interViewData}
          locations={locations}
          getInterViewLocation={getInterViewLocation}
          getListOfCountries={getListOfCountries}
          getListOfStates={getListOfStates}
          getListOfCities={getListOfCities}
          listOfCountries={listOfCountries}
          listOfStates={listOfStates}
          listOfCities={listOfCities}
          selectedLocationId={selectedLocationId}
          setSelectedLocationId={setSelectedLocationId}
          handleLocationData={handleLocationData}
          addCorporateBranch={addCorporateBranch}
          setLocationLoading={setLocationLoading}
          singleLocationData={singleLocationData}
        />
      )}
      {preview && (
        <OneToOnePreview
          interviewType={interviewType}
          interviewInfo={interviewInfo}
          interviewTime={interviewTime}
          interviewdate={interviewdate}
          driveInterViewerList={driveInterViewerList}
          isSingleOrBulk={isSingleOrBulk}
          selectedCandidate={selectedCandidate}
          setCreateSlotDrawer={setCreateSlotDrawer}
          setPrivew={setPreview}
          setSlotPrivew={setSlotPreview}
          scheduleInterview={scheduleInterview}
          preview={preview}
          interviewMode={interviewMode}
          isOneDayDrive={isOneDayDrive}
          setInterviewType={setInterviewType}
          isLoading={isLoading}
          candidateInfoData={candidateInfoData}
          confirmedResponse={confirmedResponse}
          count={candidateDeatils?.candidateList?.count}
          isBulk={
            isAllSelected
            // selectedCandidate?.length === 10 ||
            // selectedCandidate?.length === candidateDeatils?.candidateList?.count
          }
          setDateArr={setDateArr}
          dateArr={dateArr}
          selectedRoundType={selectedRoundType}
        />
      )}
      {slotPreview && (
        <SlotPreviewDrawer
          slotpreview={slotPreview}
          setPrivew={setPreview}
          setSlotPrivew={setSlotPreview}
          slotTime={interviewTime?.timeRange}
          setCreateSlotDrawer={setCreateSlotDrawer}
          candidateDeatils={candidateDeatils}
          interviewInfo={interviewInfo}
          interviewdate={interviewdate}
          setSchedulePreview={setSchedulePreview}
          dateArr={dateArr}
          locationLoading={locationLoading}
        />
      )}
    </>
  )
}

export default CreateSlots
